import { makeAutoObservable } from "mobx";

export default class OfferQuickModel {
  constructor() {
    makeAutoObservable(this);
  }

  id = "";
  title = "";
  image = "";
  expire_time = "";
  address = [];
}
